import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import {
  MonthYearDateFormatter,
  ValueTickFormatter,
} from 'src/utils/TickFormatters';
import { useRoiDef } from 'src/utils/calculateRoi';
import { useLTDataContext } from '../../contexts/LTDataContext';

const title = 'ROI';

export const RoiOTBox: React.FC = () => {
  const { roi, isError, isLoading } = useLTDataContext();
  const roiDef = useRoiDef();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return roi.monthly.map((month) => ({
      utcEpoch: month.utcEpoch,
      value: month.totalEffectROI,
    }));
  }, [roi]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={title}
      data={data}
      xAxisFormatter={MonthYearDateFormatter}
      yAxisFormatter={ValueTickFormatter}
      isError={isError}
      isLoading={isLoading}
      infoHeader="Return on Investment"
      infoText={roiDef}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={ValueTickFormatter}
          dateFormatter={MonthYearDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
